export default __webpack_public_path__ + "media/pro/checkmark_white-8b530e82.svg";